export default function CrossbetPicker({ onSelectMatch, onSelect1v1, onSelectTable, onSelectSeasonals }) {

  const formats = [
    {
      id: '1v1',
      icon: '⚔️',
      label: '1V1 CROSSBET',
      desc: 'Head to head — any sport, any event, one wager',
      color: '#1A1814',
      onClick: onSelect1v1,
      live: true,
    },
    {
      id: 'table',
      icon: '🎯',
      label: 'CROSSBET TABLE',
      desc: 'Group pool — 3+ players, pick winners, everyone throws in',
      color: '#1A1814',
      onClick: onSelectTable,
      live: true,
    },
    {
      id: 'match',
      icon: '🏆',
      label: 'CROSSBET MATCH',
      desc: 'Structured games with scoring — Golf, Bowling, Darts & more',
      color: '#00563F',
      onClick: onSelectMatch,
      live: true,
    },
    {
      id: 'seasonals',
      icon: '🌍',
      label: 'SEASONALS',
      desc: 'Long-form competitions — World Cup quiniela, brackets, leagues',
      color: '#1A1814',
      onClick: onSelectSeasonals,
      live: false,
    },
  ]

  return (
    <div style={s.screen}>
      <div style={s.body}>
        <div style={s.intro}>
          <div style={s.introLabel}>WHAT ARE YOU BETTING ON?</div>
          <div style={s.introSub}>Pick a format to get started</div>
        </div>

        {formats.map(f => (
          <button key={f.id} style={{ ...s.card, ...(f.live ? s.cardLive : s.cardDim) }} onClick={f.onClick}>
            <div style={s.cardLeft}>
              <div style={s.cardIcon}>{f.icon}</div>
              <div style={s.cardInfo}>
                <div style={{ ...s.cardLabel, color: f.live ? f.color : '#7A7570' }}>{f.label}</div>
                <div style={s.cardDesc}>{f.desc}</div>
              </div>
            </div>
            <div style={s.cardRight}>
              {f.live
                ? <div style={s.liveArrow}>→</div>
                : <div style={s.comingSoon}>Soon</div>}
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

const s = {
  screen: { display: 'flex', flexDirection: 'column', fontFamily: "'DM Sans', sans-serif", background: '#FDF9E7' },
  body: { padding: '20px 24px 48px', display: 'flex', flexDirection: 'column', gap: 12 },
  intro: { marginBottom: 8 },
  introLabel: { fontFamily: "'Outfit', sans-serif", fontWeight: 700, fontSize: 22, color: '#1A1814', letterSpacing: 1 },
  introSub: { fontSize: 13, color: '#7A7570', marginTop: 4 },
  card: { background: '#FFFFFF', border: '1.5px solid #E0DDD4', borderRadius: 20, padding: '18px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 14, cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  cardLive: { borderColor: 'rgba(0,96,57,0.25)', background: '#FFFFFF' },
  cardDim: { opacity: 0.6 },
  cardLeft: { display: 'flex', alignItems: 'center', gap: 14, flex: 1 },
  cardIcon: { fontSize: 36, flexShrink: 0 },
  cardInfo: { flex: 1 },
  cardLabel: { fontFamily: "'Outfit', sans-serif", fontWeight: 700, fontSize: 22, letterSpacing: 1, marginBottom: 4 },
  cardDesc: { fontSize: 13, color: '#7A7570', lineHeight: 1.5 },
  cardRight: { flexShrink: 0 },
  liveArrow: { fontSize: 20, color: '#00563F', fontWeight: 700 },
  comingSoon: { fontSize: 10, fontWeight: 700, color: '#7A7570', background: '#EDE8D8', borderRadius: 8, padding: '4px 8px', letterSpacing: 1 },
}
